import { ModuleAction } from '../Module/_actions/ModuleActions';
import ModuleInfo, { Categories } from '../Module/_config/ModuleInfo';
import ModuleStore from '../Module/_stores/ModuleStore';
import EffectHandler from './EffectHandler';
import GeneratorHandler from './GeneratorHandler';
import ImageHandler from './ImageHandler';
import ShapeHandler from './ShapeHandler';
import TransformHandler from './TransformHandler';
import Webgl from '../Webgl/Webgl';

export default (module: ModuleStore, webgl: Webgl, documentWidth:number, documentHeight:number, quality:number, useChunks:boolean, updater: (key:string, value:any) => ModuleAction) => {
	let handler:IHandler;
	switch(ModuleInfo[module.get('type')].category) {
		case Categories.Images		: handler = new ImageHandler(); break;
		case Categories.Shapes		: handler = new ShapeHandler(); break;
		case Categories.Transforms	: handler = new TransformHandler(); break;
		//case Categories.Generators	: handler = new GeneratorHandler(); break;
		case Categories.Effects		: handler = new EffectHandler(); break;
	}

	handler.getOutput(module, webgl, documentWidth, documentHeight, quality, false, updater);
};

export interface IHandler {
	getOutput(module: ModuleStore, webgl: Webgl, documentWidth:number, documentHeight:number, quality:number, useChunks:boolean, updater: (key:string, value:any) => ModuleAction): void
}